import { Currency } from "Application/features/models/Home/Currency";
import { sibaBackendApi } from "../../backends/sibaApis";
import { Salvage } from "Application/features/models/Home/Salvage";

const api = "api/salvageexternal";
/***
 * Service definition for Salvage setup
 *  */
const SalvageExternalApi = sibaBackendApi.injectEndpoints({
    endpoints: (builder) => ({
        getSalvageById: builder.mutation<Salvage, string>({
            query: (id: string) => ({
                url: `${api}/${id}`,
                method: "GET"
            })
        }),
        /**
         * Sample query method using rtk mutation instead of rtk query.
         */
        getAllSalvages: builder.mutation<Salvage[], void>({
            query: () => ({
                url: `${api}/unclosed`,
                method: "GET"
            })
        }),
        getAllCurrencies: builder.mutation<Currency[], void>({
            query: () => ({
                url: `${api}/currencies`,
                method: "GET"
            })
        }),
    })
});

export const {
    useGetAllSalvagesMutation,
    useGetSalvageByIdMutation,
    useGetAllCurrenciesMutation
} = SalvageExternalApi;
